<template>
  <div class="spinner-container">
    <div class="spinner spinner-md"></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner'
}
</script>

<style scoped>
@keyframes spinner {
  0% {
    transform: translate3d(-50%, -50%, 0) rotate(0deg);
  }
  100% {
    transform: translate3d(-50%, -50%, 0) rotate(360deg);
  }
}

.spinner-container {
  display: flex;
  flex: 1;
  position: relative;
  justify-content: center;
  align-items: center;
}

.spinner {
  opacity: 1;
  position: relative;
  transition: opacity linear 0.1s;
}

.spinner::before {
  animation: 500ms linear infinite spinner;
  border: solid 3px transparent;
  border-bottom-color: #333;
  border-radius: 50%;
  content: '';
  height: 20px;
  width: 20px;
  opacity: inherit;
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  transform-origin: center;
  will-change: transform;
}

.spinner.spinner-sm::before,
.spinner.spinner-md::before {
  top: 0;
}
.spinner.spinner-lg::before {
  top: 0;
}
</style>